import { render, staticRenderFns } from "./OfficialFeePaymentInstitutionForm.vue?vue&type=template&id=6ca0c89b&"
import script from "./OfficialFeePaymentInstitutionForm.vue?vue&type=script&lang=js&"
export * from "./OfficialFeePaymentInstitutionForm.vue?vue&type=script&lang=js&"
import style0 from "./OfficialFeePaymentInstitutionForm.vue?vue&type=style&index=0&id=6ca0c89b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports